<template>
  <div id="app">
    <app-header class="sticky-top"></app-header>
    <router-view></router-view>
  </div>
</template>

<script>
import Header from '@/components/Header'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  name: 'app',
  created () {
    this.$store.dispatch('user/onAuthStateChanged')
  },
  components: {
    'app-header': Header
  }
}
</script>

<style>
:root {
  --test: #ddd;
}
</style>
